import buildJourneyUrl from './buildJourneyUrl'
import validateDomain from './validateDomain'

const guestPortal = {
  buildJourneyUrl,
  validateDomain,
}

export default guestPortal
